module.exports = __webpack_public_path__ + "img/FolderOutlined.b24112cf.svg";